const TURKISH_CHAR_MAP = {
	ç: 'c',
	ğ: 'g',
	ı: 'i',
	ö: 'o',
	ş: 's',
	ü: 'u',
	Ç: 'c',
	Ğ: 'g',
	İ: 'i',
	I: 'i',
	Ö: 'o',
	Ş: 's',
	Ü: 'u',
};

const INVALID_SHEET_NAME_CHARS = /[\\/?*[\]:]/g;
const MAX_SHEET_NAME_LENGTH = 31;

export const slugify = text =>
	String(text)
		.split('')
		.map(char => TURKISH_CHAR_MAP[char] || char)
		.join('')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');

export const sanitizeSheetName = name => {
	const sanitized = String(name)
		.replace(INVALID_SHEET_NAME_CHARS, ' ')
		.replace(/\s+/g, ' ')
		.trim()
		.slice(0, MAX_SHEET_NAME_LENGTH);
	return sanitized || 'Sheet';
};

export const chartDataToRows = ({ labels = [], datasets = [] }) =>
	labels.map((label, index) => [
		label,
		...datasets.map(dataset =>
			dataset.data && dataset.data[index] != null ? dataset.data[index] : 0,
		),
	]);

export const exportSheetsToXlsx = async ({ fileName, sheets }) => {
	const XLSX = await import(/* webpackChunkName: "xlsx" */ 'xlsx');
	const workbook = XLSX.utils.book_new();
	sheets.forEach(({ name, header, rows }) => {
		const worksheet = XLSX.utils.aoa_to_sheet([header, ...rows]);
		XLSX.utils.book_append_sheet(workbook, worksheet, sanitizeSheetName(name));
	});
	XLSX.writeFile(workbook, fileName);
};
